import http from 'hub-http/clients/apiClient';
import { useEffect, useState } from 'react';
import { getAssociatedLineItems } from '../api/CrmSearchApi';
import { INVOICE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const VALIDATE_INVOICE_ENDPOINT = 'invoices/v1/validation/with-associated-objects/create';
export const VALIDATION_SUB_CATEGORIES = {
  FUTURE_START_DATE_LINE_ITEMS_UNSUPPORTED: 'InvoicePaymentValidationError.FUTURE_START_DATE_LINE_ITEMS_UNSUPPORTED',
  RECURRING_LINE_ITEMS_UNSUPPORTED: 'InvoicePaymentValidationError.RECURRING_LINE_ITEMS_UNSUPPORTED',
  UNSUPPORTED_CURRENCIES: 'InvoicePaymentValidationError.UNSUPPORTED_CURRENCIES',
  INVALID_LINE_ITEM_QUANTITY_FRACTIONAL: 'InvoicePaymentValidationError.INVALID_LINE_ITEM_QUANTITY_FRACTIONAL',
  INVALID_LINE_ITEM_QUANTITY_MAX: 'InvoicePaymentValidationError.INVALID_LINE_ITEM_QUANTITY_MAX',
  LINE_ITEM_SIZE_EXCEEDED: 'InvoiceAssociatedObjectValidationError.LINE_ITEM_SIZE_EXCEEDED'
};
export const getValidationErrorMessage = validationMessage => {
  switch (validationMessage.subCategory) {
    case VALIDATION_SUB_CATEGORIES.RECURRING_LINE_ITEMS_UNSUPPORTED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.convertToInvoiceButton.tooltip.recurringLineItems"
      }, validationMessage.subCategory);
    case VALIDATION_SUB_CATEGORIES.UNSUPPORTED_CURRENCIES:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.convertToInvoiceButton.tooltip.currency_new"
      }, validationMessage.subCategory);
    case VALIDATION_SUB_CATEGORIES.FUTURE_START_DATE_LINE_ITEMS_UNSUPPORTED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.convertToInvoiceButton.tooltip.futureStartDate"
      }, validationMessage.subCategory);
    case VALIDATION_SUB_CATEGORIES.INVALID_LINE_ITEM_QUANTITY_FRACTIONAL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.convertToInvoiceButton.tooltip.fractionalQuantity"
      }, validationMessage.subCategory);
    case VALIDATION_SUB_CATEGORIES.INVALID_LINE_ITEM_QUANTITY_MAX:
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "quotesUiLib.convertToInvoiceButton.tooltip.quantityMax_jsx",
        elements: {
          FormattedNumber
        },
        options: {
          numberProps: {
            value: Number(validationMessage.context.quantityMax[0])
          }
        }
      }, validationMessage.subCategory);
    case VALIDATION_SUB_CATEGORIES.LINE_ITEM_SIZE_EXCEEDED:
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "quotesUiLib.convertToInvoiceButton.tooltip.lineItemMax_jsx",
        elements: {
          FormattedNumber
        },
        options: {
          numberProps: {
            value: Number(validationMessage.context.maxLineItemSize[0])
          }
        }
      }, validationMessage.subCategory);
    default:
      return null;
  }
};
const createInvoiceRequest = (currency, lineItems, portalId) => ({
  objectId: null,
  objectTypeId: INVOICE_TYPE_ID,
  portalId,
  associatedObjects: {
    INVOICE_TO_LINE_ITEM: lineItems.map(lineItem => ({
      objectId: lineItem.objectId,
      objectTypeId: lineItem.objectTypeId,
      portalId: lineItem.portalId,
      properties: Object.entries(lineItem.properties).map(([name, propertyValue]) => ({
        name,
        value: propertyValue.value
      }))
    }))
  },
  properties: [{
    name: 'hs_currency',
    value: currency
  }]
});
const getValidateInvoice = data => http.post(VALIDATE_INVOICE_ENDPOINT, {
  data
});
const useCanConvertQuoteToInvoice = ({
  quoteId,
  quoteCurrency,
  portalId,
  skip
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [validationErrorMessages, setValidationErrorMessages] = useState([]);
  const [unknownValidationError, setUnknownValidationError] = useState(false);
  useEffect(() => {
    if (skip || !quoteId || !quoteCurrency || !portalId) {
      setLoading(false);
      setError(false);
      setValidationErrorMessages([]);
    } else {
      setLoading(true);
      getAssociatedLineItems(quoteId, portalId).then(lineItems => getValidateInvoice(createInvoiceRequest(quoteCurrency, lineItems, portalId))).then(validationMessages => {
        const errorMessages = validationMessages.map(validationMessage => getValidationErrorMessage(validationMessage)).filter(value => !!value);
        if (validationMessages.length === errorMessages.length) {
          setValidationErrorMessages(errorMessages);
        } else {
          setUnknownValidationError(true);
        }
      }).catch(() => setError(true)).finally(() => setLoading(false));
    }
  }, [portalId, quoteCurrency, quoteId, skip]);
  return {
    validationErrorMessages,
    error,
    loading,
    unknownValidationError
  };
};
export default useCanConvertQuoteToInvoice;